<template>
  <div class="fake-input"><span class="holder">{{placeholder}}</span></div>
</template>

<script>
export default {
    props:["placeholder"]
}
</script>

<style lang="scss" scoped>
    .fake-input{
        user-select: none;
        text-rendering: auto;
        color: -internal-light-dark(black, white);
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        display: inline-block;
        text-align: start;
        appearance: textfield;
        background-color: -internal-light-dark(rgb(255, 255, 255), rgb(59, 59, 59));
        -webkit-rtl-ordering: logical;
        cursor: pointer;
        margin: 0em;
        font: 400 13.3333px Arial;
        padding: 1px 15px;
        border-width: 2px;
        border-style: inset;
        border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133));
        border-image: initial;
        .holder{
            color: #606266;
        }
    }
</style>